export const RECAPTCHA_ACTION_REQUEST_OTP = "request_otp";
export const RECAPTCHA_ACTION_SIGNUP = "signup";

export async function executeRecaptcha(action) {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (!siteKey) {
    throw new Error("reCAPTCHA is not configured.");
  }

  const g = window.grecaptcha?.enterprise;

  if (!g) {
    throw new Error(
      "reCAPTCHA failed to load. Please refresh and try again."
    );
  }

  await new Promise((resolve) => {
    g.ready(() => resolve());
  });

  return g.execute(siteKey, { action });
}